/**
 * Tek bir kaynaktan tesis türleri (frontend tüm dosyalardan referans).
 * Backend ile senkron tutulmalı: /app/backend/server.py → FACILITY_TYPE_SEO
 */
export const FACILITY_TYPES = [
  { value: 'hali_saha', label: 'Halı Saha' },
  { value: 'kapali_spor_salonu', label: 'Kapalı Spor Salonu' },
  { value: 'voleybol_sahasi', label: 'Voleybol Sahası' },
  { value: 'basketbol_sahasi', label: 'Basketbol Sahası' },
  { value: 'tenis_kortu', label: 'Tenis Kortu' },
  { value: 'yuzme_havuzu', label: 'Yüzme Havuzu' },
  { value: 'plaj_voleybolu', label: 'Plaj Voleybolu Sahası' },
  { value: 'masa_tenisi', label: 'Masa Tenisi Salonu' },
];

export const getFacilityTypeLabel = (value) => {
  const found = FACILITY_TYPES.find((t) => t.value === value);
  return found ? found.label : (value || 'Tesis');
};
